export default __webpack_public_path__ + "static/media/Clock_Black.16b32f82.webp";